import {SETTING} from "../types";

export function setting (params) {
    return {
        type: SETTING,
        payload:params
    };
}
